// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

/**
 * Normalize a date string to ISO `YYYY-MM-DD`.
 *
 * The date inputs in the wizard toggle between `type="text"` (for the
 * "DD/MM/YYYY" placeholder) and `type="date"`. Depending on how the value
 * lands in state (native picker, manual typing, browser autofill, paste) it
 * can end up as the visible `DD/MM/YYYY` string instead of the ISO format the
 * validator and backend expect. This converts that visible format to ISO.
 *
 * - ISO `YYYY-MM-DD` is passed through unchanged.
 * - `DD/MM/YYYY` is converted to `YYYY-MM-DD`.
 * - Anything else is returned unchanged so the validator can still reject it.
 */
export function toIsoDate(value: string): string {
  if (!value) return value;
  const trimmed = value.trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;
  const m = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  return trimmed;
}
